export default __webpack_public_path__ + "static/media/wwd-block-3.5aaf8ad3.jpg";